export const LANGS = ["de", "it", "en"];

export const translations = {
  de: {
    nav: { services: "Leistungen", about: "Otto", partners: "Partner", gallery: "Referenzen", reviews: "Bewertungen", contact: "Kontakt", cta: "WhatsApp" },
    hero: {
      badge: "Elektrotechnik · Südtirol",
      claim: ["Power", "Performance", "Precision"],
      lead: "WLAN- & Netzwerksysteme, TV-Senderlisten und Smart Home für Hotels, Garnis und private Häuser.",
      ctaPrimary: "Projekt anfragen",
      ctaSecondary: "Leistungen entdecken",
      stats: [
        { top: "Made in", headline: "Südtirol", label: "Regional & persönlich" },
        { num: 100, suffix: "%", label: "Maßgeschneidert" },
      ],
      apLabel: "Realisierte Projekte",
      projectsLabel: "Realisierte Projekte",
      apsLabel: "Montierte Access Points",
      foundedLabel: "Gründungsjahr",
    },
    services: {
      overline: "Was wir bauen",
      title: "Technik, die verbindet.",
      lead: "Von der Netzwerkplanung bis zum vollintegrierten Smart Home – zuverlässig, sauber, zukunftssicher.",
      items: [
        { n: "01", title: "WLAN & Netzwerksysteme", desc: "Lückenlose Abdeckung und stabile Netzwerke für Häuser und Hotels – strukturiert verkabelt und professionell konfiguriert." },
        { n: "02", title: "TV-Senderlisten-Systeme", desc: "Perfekt sortierte Senderlisten und moderne TV-Verteilung für Garnis, Pensionen und Hotels." },
        { n: "03", title: "Smart Home Lösungen", desc: "Licht, Klima, Sicherheit und Multimedia intelligent vernetzt und intuitiv steuerbar." },
        { n: "04", title: "Videoüberwachungsanlagen", desc: "Professionelle Videoüberwachung für Sicherheit rund um die Uhr – zuverlässig geplant und montiert." },
      ],
    },
    manifesto: {
      overline: "Unser Anspruch",
      title: ["Jedes Projekt ist", "individuell auf den", "Kunden abgestimmt."],
      body: "Keine Lösung von der Stange. Wir analysieren Ihre Räume, Ihre Gäste und Ihre Ziele – und entwickeln daraus ein maßgeschneidertes System, das exakt passt.",
      marquee: "Maßgeschneidert · Präzise · Exklusiv · Zukunftssicher · ",
      chapters: [
        { n: "01", title: "Analyse vor Ort", desc: "Wir verstehen Gebäude, Nutzung und Anforderungen bis ins Detail." },
        { n: "02", title: "Maßgeschneiderte Planung", desc: "Jede Komponente wird individuell auf Ihr Projekt abgestimmt." },
        { n: "03", title: "Präzise Umsetzung", desc: "Saubere Montage und Konfiguration – zuverlässig und langlebig." },
        { n: "04", title: "Qualifikation & Dokumentation", desc: "Zertifizierte Messung und Dokumentation Ihrer Anlage bis 1 Gbit – nachvollziehbar und normgerecht." },
      ],
    },
    about: {
      title: "Elektrotechniker Otto",
    },
    partners: {
      overline: "Vertrauen",
      title: "Partner",
      lead: "Wir arbeiten mit starken Partnern und Herstellern zusammen.",
      empty: "Partnereinträge folgen in Kürze.",
    },
    contact: {
      overline: "Kontakt",
      title: "Sprechen wir über Ihr Projekt.",
      lead: "Schreiben Sie uns – wir melden uns zeitnah zurück.",
      form: { name: "Name", email: "E-Mail", phone: "Telefon", subject: "Betreff", message: "Ihre Nachricht", send: "Anfrage senden", sending: "Wird gesendet…" },
      success: "Danke! Ihre Anfrage wurde gesendet.",
      error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      phoneLabel: "Telefon",
      emailLabel: "E-Mail",
      whatsapp: "WhatsApp Chat",
    },
    hotels: {
      overline: "Referenzen",
      title: "Unsere Kunden",
      lead: "Hotels, Garnis, Pensionen und Betriebe, die auf PowerTech vertrauen.",
      empty: "Kunden folgen in Kürze.",
    },
    testimonials: {
      overline: "Kundenstimmen",
      title: "Was unsere Kunden sagen.",
      lead: "Echtes Feedback von Hotels, Garnis und Betrieben. Teilen auch Sie Ihre Erfahrung.",
      cta: "Bewertung abgeben",
      empty: "Noch keine Bewertungen – seien Sie die oder der Erste und teilen Sie Ihre Erfahrung.",
      dialogTitle: "Ihre Bewertung",
      form: { name: "Ihr Name", role: "Hotel / Funktion (optional)", message: "Ihre Erfahrung mit PowerTech", rating: "Bewertung", submit: "Bewertung senden", sending: "Wird gesendet…" },
      success: "Vielen Dank! Ihre Bewertung wird nach kurzer Prüfung veröffentlicht.",
      reviewsCount: "Bewertungen",
      error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    },
    footer: { tagline: "Smart Solutions for a connected world", rights: "Alle Rechte vorbehalten.", admin: "Admin", impressum: "Impressum", datenschutz: "Datenschutz" },
    gallery: {
      overline: "Referenzen",
      title: "Einblicke in unsere Arbeit.",
      lead: "Ausgewählte Projekte aus Netzwerktechnik, Smart Home und Videoüberwachung.",
      items: ["Netzwerk & Serverschrank", "Strukturierte Verkabelung", "Smart-Home-Steuerung", "Videoüberwachung", "WLAN im Hotel"],
      note: "Beispielbilder – echte Projektfotos folgen in Kürze.",
    },
    legal: {
      back: "Zurück zur Startseite",
      impressum: {
        title: "Impressum",
        intro: "Angaben gemäß den geltenden gesetzlichen Bestimmungen.",
        companyLabel: "Firmenbezeichnung",
        ownerLabel: "Inhaber / Verantwortlicher",
        addressLabel: "Anschrift",
        vatLabel: "MwSt-Nr. (P.IVA)",
        cfLabel: "Steuernummer (Cod. Fiscale)",
        phoneLabel: "Telefon",
        emailLabel: "E-Mail",
        pecLabel: "PEC (zertifizierte E-Mail)",
      },
      privacy: {
        title: "Datenschutzerklärung",
        sections: [
          { h: "1. Verantwortlicher", p: "Verantwortlich für die Datenverarbeitung auf dieser Website ist Otto Zingerle (PowerTech des Zingerle Otto), Str. Tor 83, 39030 St. Martin in Thurn (BZ), Italien." },
          { h: "2. Erhebung von Daten", p: "Diese Website erhebt keine personenbezogenen Daten automatisch. Es werden keine Cookies gesetzt und es findet kein Tracking oder keine Web-Analyse (z. B. Google Analytics) statt." },
          { h: "3. Kontaktaufnahme", p: "Wenn Sie uns per Telefon, WhatsApp oder E-Mail kontaktieren, werden die übermittelten Daten ausschließlich zur Bearbeitung Ihrer Anfrage verwendet und nicht an Dritte weitergegeben." },
          { h: "4. Ihre Rechte", p: "Nach der DSGVO haben Sie das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Wenden Sie sich hierfür an die oben genannten Kontaktdaten." },
          { h: "5. Bildrechte", p: "Alle auf dieser Website verwendeten Bilder werden mit ausdrücklicher Genehmigung des Inhabers verwendet. Eine weitere Nutzung ohne Zustimmung ist nicht gestattet." },
        ],
      },
    },
  },
  it: {
    nav: { services: "Servizi", about: "Otto", partners: "Partner", gallery: "Referenze", reviews: "Recensioni", contact: "Contatti", cta: "WhatsApp" },
    hero: {
      badge: "Elettrotecnica · Alto Adige",
      claim: ["Power", "Performance", "Precision"],
      lead: "Sistemi WLAN e di rete, liste canali TV e Smart Home per hotel, garni e case private.",
      ctaPrimary: "Richiedi un progetto",
      ctaSecondary: "Scopri i servizi",
      stats: [
        { top: "Made in", headline: "Alto Adige", label: "Regionale e personale" },
        { num: 100, suffix: "%", label: "Su misura" },
      ],
      apLabel: "Progetti realizzati",
      projectsLabel: "Progetti realizzati",
      apsLabel: "Access Point installati",
    },
    services: {
      overline: "Cosa realizziamo",
      title: "Tecnologia che collega.",
      lead: "Dalla progettazione di rete alla Smart Home integrata – affidabile, pulito, a prova di futuro.",
      items: [
        { n: "01", title: "Sistemi WLAN e di rete", desc: "Copertura completa e reti stabili per case e hotel – cablaggio strutturato e configurazione professionale." },
        { n: "02", title: "Sistemi liste canali TV", desc: "Liste canali perfettamente ordinate e distribuzione TV moderna per garni, pensioni e hotel." },
        { n: "03", title: "Soluzioni Smart Home", desc: "Luce, clima, sicurezza e multimedia connessi in modo intelligente e facili da controllare." },
        { n: "04", title: "Impianti di videosorveglianza", desc: "Videosorveglianza professionale per la sicurezza 24 ore su 24 – progettata e installata in modo affidabile." },
      ],
    },
    manifesto: {
      overline: "La nostra ambizione",
      title: ["Ogni progetto è", "personalizzato sul", "singolo cliente."],
      body: "Nessuna soluzione standard. Analizziamo i vostri spazi, i vostri ospiti e i vostri obiettivi – e da questo sviluppiamo un sistema su misura, perfettamente calzante.",
      marquee: "Su misura · Preciso · Esclusivo · A prova di futuro · ",
      chapters: [
        { n: "01", title: "Analisi in loco", desc: "Comprendiamo edificio, utilizzo ed esigenze nei minimi dettagli." },
        { n: "02", title: "Progettazione su misura", desc: "Ogni componente è studiato individualmente per il vostro progetto." },
        { n: "03", title: "Realizzazione precisa", desc: "Montaggio e configurazione puliti – affidabili e duraturi." },
        { n: "04", title: "Qualificazione e documentazione", desc: "Misurazione certificata e documentazione del vostro impianto fino a 1 Gbit – tracciabile e a norma." },
      ],
    },
    about: {
      title: "Elettrotecnico Otto",
    },
    partners: {
      overline: "Fiducia",
      title: "Partner",
      lead: "Collaboriamo con partner e produttori affidabili.",
      empty: "Le voci partner arriveranno a breve.",
    },
    contact: {
      overline: "Contatti",
      title: "Parliamo del vostro progetto.",
      lead: "Scriveteci – vi risponderemo al più presto.",
      form: { name: "Nome", email: "E-mail", phone: "Telefono", subject: "Oggetto", message: "Il vostro messaggio", send: "Invia richiesta", sending: "Invio in corso…" },
      success: "Grazie! La vostra richiesta è stata inviata.",
      error: "Qualcosa è andato storto. Riprovare.",
      phoneLabel: "Telefono",
      emailLabel: "E-mail",
      whatsapp: "Chat WhatsApp",
    },
    hotels: {
      overline: "Referenze",
      title: "I nostri clienti",
      lead: "Hotel, garni, pensioni e aziende che si affidano a PowerTech.",
      empty: "Clienti in arrivo a breve.",
    },
    testimonials: {
      overline: "Recensioni",
      title: "Cosa dicono i nostri clienti.",
      lead: "Feedback autentici di hotel, garni e aziende. Condividete anche voi la vostra esperienza.",
      cta: "Lascia una recensione",
      empty: "Ancora nessuna recensione – siate i primi a condividere la vostra esperienza.",
      dialogTitle: "La vostra recensione",
      form: { name: "Il vostro nome", role: "Hotel / ruolo (facoltativo)", message: "La vostra esperienza con PowerTech", rating: "Valutazione", submit: "Invia recensione", sending: "Invio in corso…" },
      success: "Grazie! La vostra recensione sarà pubblicata dopo una breve verifica.",
      reviewsCount: "recensioni",
      error: "Qualcosa è andato storto. Riprovare.",
    },
    footer: { tagline: "Smart Solutions for a connected world", rights: "Tutti i diritti riservati.", admin: "Admin", impressum: "Note legali", datenschutz: "Privacy" },
    gallery: {
      overline: "Referenze",
      title: "Uno sguardo al nostro lavoro.",
      lead: "Progetti selezionati di reti, Smart Home e videosorveglianza.",
      items: ["Rete e armadio server", "Cablaggio strutturato", "Controllo Smart Home", "Videosorveglianza", "WLAN in hotel"],
      note: "Immagini esemplificative – le foto reali dei progetti seguiranno a breve.",
    },
    legal: {
      back: "Torna alla home",
      impressum: {
        title: "Note legali",
        intro: "Informazioni ai sensi delle disposizioni di legge vigenti.",
        companyLabel: "Ragione sociale",
        ownerLabel: "Titolare / Responsabile",
        addressLabel: "Indirizzo",
        vatLabel: "P.IVA",
        cfLabel: "Codice Fiscale",
        phoneLabel: "Telefono",
        emailLabel: "E-mail",
        pecLabel: "PEC",
      },
      privacy: {
        title: "Informativa sulla privacy",
        sections: [
          { h: "1. Titolare del trattamento", p: "Il titolare del trattamento dei dati su questo sito è Otto Zingerle (PowerTech des Zingerle Otto), Str. Tor 83, 39030 San Martino in Badia (BZ), Italia." },
          { h: "2. Raccolta dei dati", p: "Questo sito non raccoglie automaticamente dati personali. Non vengono utilizzati cookie e non viene effettuato alcun tracciamento o analisi web (es. Google Analytics)." },
          { h: "3. Contatti", p: "Se ci contattate per telefono, WhatsApp o e-mail, i dati trasmessi vengono utilizzati esclusivamente per gestire la vostra richiesta e non vengono ceduti a terzi." },
          { h: "4. I vostri diritti", p: "In base al GDPR avete diritto di accesso, rettifica, cancellazione e limitazione del trattamento dei vostri dati personali. Per esercitarli, utilizzate i contatti sopra indicati." },
          { h: "5. Diritti sulle immagini", p: "Tutte le immagini utilizzate su questo sito sono impiegate con l'esplicito consenso del titolare. Ogni ulteriore utilizzo senza autorizzazione non è consentito." },
        ],
      },
    },
  },
  en: {
    nav: { services: "Services", about: "Otto", partners: "Partners", gallery: "References", reviews: "Reviews", contact: "Contact", cta: "WhatsApp" },
    hero: {
      badge: "Electrical Engineering · South Tyrol",
      claim: ["Power", "Performance", "Precision"],
      lead: "WLAN & network systems, TV channel-list systems and Smart Home for hotels, guesthouses and private homes.",
      ctaPrimary: "Request a project",
      ctaSecondary: "Explore services",
      stats: [
        { top: "Made in", headline: "South Tyrol", label: "Regional & personal" },
        { num: 100, suffix: "%", label: "Bespoke" },
      ],
      apLabel: "Completed projects",
      projectsLabel: "Completed projects",
      apsLabel: "Access points installed",
      foundedLabel: "Founded",
    },
    services: {
      overline: "What we build",
      title: "Technology that connects.",
      lead: "From network planning to a fully integrated Smart Home – reliable, clean, future-proof.",
      items: [
        { n: "01", title: "WLAN & Network Systems", desc: "Seamless coverage and stable networks for homes and hotels – structured cabling and professional configuration." },
        { n: "02", title: "TV Channel-List Systems", desc: "Perfectly sorted channel lists and modern TV distribution for guesthouses, pensions and hotels." },
        { n: "03", title: "Smart Home Solutions", desc: "Lighting, climate, security and multimedia intelligently connected and intuitively controlled." },
        { n: "04", title: "Video Surveillance Systems", desc: "Professional video surveillance for round-the-clock security – reliably planned and installed." },
      ],
    },
    manifesto: {
      overline: "Our standard",
      title: ["Every project is", "individually tailored", "to the client."],
      body: "No off-the-shelf solutions. We analyse your spaces, your guests and your goals – and build a bespoke system from that, one that fits exactly.",
      marquee: "Bespoke · Precise · Exclusive · Future-proof · ",
      chapters: [
        { n: "01", title: "On-site analysis", desc: "We understand the building, its use and requirements in full detail." },
        { n: "02", title: "Tailored planning", desc: "Every component is individually matched to your project." },
        { n: "03", title: "Precise execution", desc: "Clean installation and configuration – reliable and long-lasting." },
        { n: "04", title: "Qualification & documentation", desc: "Certified measurement and documentation of your installation up to 1 Gbit – traceable and standard-compliant." },
      ],
    },
    about: {
      title: "Electrical Technician Otto",
    },
    partners: {
      overline: "Trust",
      title: "Partners",
      lead: "We work with strong partners and manufacturers.",
      empty: "Partner entries coming soon.",
    },
    contact: {
      overline: "Contact",
      title: "Let's talk about your project.",
      lead: "Drop us a line – we'll get back to you shortly.",
      form: { name: "Name", email: "Email", phone: "Phone", subject: "Subject", message: "Your message", send: "Send request", sending: "Sending…" },
      success: "Thanks! Your request has been sent.",
      error: "Something went wrong. Please try again.",
      phoneLabel: "Phone",
      emailLabel: "Email",
      whatsapp: "WhatsApp chat",
    },
    hotels: {
      overline: "References",
      title: "Our clients",
      lead: "Hotels, guesthouses, pensions and businesses that trust PowerTech.",
      empty: "Clients coming soon.",
    },
    testimonials: {
      overline: "Testimonials",
      title: "What our clients say.",
      lead: "Genuine feedback from hotels, guesthouses and businesses. Share your experience too.",
      cta: "Leave a review",
      empty: "No reviews yet – be the first to share your experience.",
      dialogTitle: "Your review",
      form: { name: "Your name", role: "Hotel / role (optional)", message: "Your experience with PowerTech", rating: "Rating", submit: "Submit review", sending: "Sending…" },
      success: "Thank you! Your review will be published after a quick check.",
      reviewsCount: "reviews",
      error: "Something went wrong. Please try again.",
    },
    footer: { tagline: "Smart Solutions for a connected world", rights: "All rights reserved.", admin: "Admin", impressum: "Legal notice", datenschutz: "Privacy" },
    gallery: {
      overline: "References",
      title: "A look at our work.",
      lead: "Selected projects across networking, smart home and video surveillance.",
      items: ["Network & server rack", "Structured cabling", "Smart home control", "Video surveillance", "Hotel WLAN"],
      note: "Sample images – real project photos coming soon.",
    },
    legal: {
      back: "Back to home",
      impressum: {
        title: "Legal notice",
        intro: "Information in accordance with applicable legal provisions.",
        companyLabel: "Company name",
        ownerLabel: "Owner / Responsible",
        addressLabel: "Address",
        vatLabel: "VAT no. (P.IVA)",
        cfLabel: "Tax code (Codice Fiscale)",
        phoneLabel: "Phone",
        emailLabel: "Email",
        pecLabel: "PEC (certified email)",
      },
      privacy: {
        title: "Privacy policy",
        sections: [
          { h: "1. Data controller", p: "The controller for data processing on this website is Otto Zingerle (PowerTech des Zingerle Otto), Str. Tor 83, 39030 St. Martin in Thurn (BZ), Italy." },
          { h: "2. Data collection", p: "This website does not collect any personal data automatically. No cookies are set and no tracking or web analytics (e.g. Google Analytics) take place." },
          { h: "3. Getting in touch", p: "If you contact us by phone, WhatsApp or email, the data you provide is used solely to process your request and is not shared with third parties." },
          { h: "4. Your rights", p: "Under the GDPR you have the right to access, rectify, erase and restrict the processing of your personal data. To exercise these rights, please use the contact details above." },
          { h: "5. Image rights", p: "All images used on this website are used with the explicit permission of the owner. Any further use without consent is not permitted." },
        ],
      },
    },
  },
};

export const CONTACT = {
  phone: "+39 370 1328705",
  phoneRaw: "+393701328705",
  email: "otto.zingerle@icloud.com",
  whatsapp: "393701328705",
};

export const COMPANY = {
  name: "PowerTech des Zingerle Otto",
  owner: "Otto Zingerle",
  address: "Str. Tor 83, 39030 St. Martin in Thurn / San Martino in Badia (BZ)",
  vat: "03351940212",
  cf: "ZNGTTO04T20B220Z",
  pec: "otto.zingerle@pec.it",
};
